<div class="transcript-options">
    <div class="d-flex justify-content-between">
        <div>
            <button
                class="cmps-icon-button--no-bg"
                cmpsIconButton
                [cmpsOverlayTrigger]="filterTpl"
                placement="bottom-left"
            >
                <cmps-icon svgIcon="filter-outline"></cmps-icon>
                <span cmpsIconButtonLabel>{{
                    _i18n._7360_FILTER | translate
                }}</span>
            </button>
            <ng-template
                let-overlay="overlay"
                #filterTpl
            >
                <cmps-filter
                    class="cmps-coaching-detail-pillar-two-transcript-summary--transcript-filter"
                    [overlay]="overlay"
                >
                    <cmps-filter-category-header>{{
                        _i18n._10044_BY_DATE | translate
                    }}</cmps-filter-category-header>
                    <cmps-filter-category-body>
                        <cmps-date-range
                            [dateRange]="state?.filterOpts?.dateRange"
                            (dateRangeChange)="_onDateRangeFilterChange($event)"
                        ></cmps-date-range>
                    </cmps-filter-category-body>

                    <cmps-filter-category-header>{{
                        _i18n._10045_BY_PARTICIPANT | translate
                    }}</cmps-filter-category-header>
                    <cmps-filter-category-body>
                        <cmps-chip-list>
                            <ng-container
                                *ngFor="let p of state?.filterParticipants"
                            >
                                <button
                                    class="participant-tag"
                                    cmpsChip
                                    [value]="p"
                                    [selected]="
                                        state?.filterOpts?.participant?.includes(
                                            p
                                        )
                                    "
                                    (click)="_onParticipantFilterClick(p)"
                                >
                                    <span>{{ p }}</span>
                                </button>
                            </ng-container>
                        </cmps-chip-list>
                    </cmps-filter-category-body>

                    <cmps-filter-category-header>{{
                        _i18n._10046_BY_BEHAVIOUR | translate
                    }}</cmps-filter-category-header>
                    <cmps-filter-category-body>
                        <cmps-chip-list>
                            <ng-container
                                *ngFor="let b of state?.filterBehaviours"
                            >
                                <button
                                    class="participant-tag"
                                    cmpsChip
                                    [value]="b"
                                    [selected]="
                                        state?.filterOpts?.behaviourId ===
                                        b.behaviourId
                                    "
                                    (click)="
                                        _onBehaviourIdFilterClick(b.behaviourId)
                                    "
                                >
                                    <span>{{ b.behaviourName }}</span>
                                </button>
                            </ng-container>
                        </cmps-chip-list>
                    </cmps-filter-category-body>

                    <cmps-filter-category-header>{{
                        _i18n._10047_BY_SUB_BEHAVIOUR | translate
                    }}</cmps-filter-category-header>
                    <cmps-filter-category-body>
                        <ng-container
                            *ngFor="let s of state?.filterSubBehaviours"
                        >
                            <button
                                class="participant-tag"
                                cmpsChip
                                [value]="s"
                                [selected]="
                                    state?.filterOpts?.subBehaviourId ===
                                    s.subBehaviourId
                                "
                                (click)="
                                    _onSubBehaviourIdFilterClick(
                                        s.subBehaviourId
                                    )
                                "
                            >
                                <span>{{ s.subBehaviourName }}</span>
                            </button>
                        </ng-container>
                    </cmps-filter-category-body>
                </cmps-filter>
            </ng-template>
        </div>

        <div>
            <button
                class="cmps-icon-button--no-bg"
                cmpsIconButton
                [cmpsMenuTrigger]="menu"
                placement="bottom-left"
            >
                <span cmpsIconButtonLabel>{{
                    _i18n._10039_ORDER_BY | translate
                }}</span>
                <cmps-icon svgIcon="order-bool-ascending-variant"></cmps-icon>
            </button>
            <cmps-menu #menu="cmpsMenu">
                <button
                    class="cmps-button--no-bg cmps-button--left"
                    cmpsButton
                    (click)="_onOrderByClick(_OrderBy.BY_DATE_MOST_RECENT)"
                >
                    <span cmpsButtonLabel>{{
                        _i18n._10040_BY_DATE_MOST_RECENT | translate
                    }}</span>
                </button>
                <button
                    class="cmps-button--no-bg cmps-button--left"
                    cmpsButton
                    (click)="_onOrderByClick(_OrderBy.BY_DATE_OLDEST)"
                >
                    <span cmpsButtonLabel>{{
                        _i18n._10041_BY_DATE_OLDEST | translate
                    }}</span>
                </button>
                <button
                    class="cmps-button--no-bg cmps-button--left"
                    cmpsButton
                    (click)="_onOrderByClick(_OrderBy.ALPHABETICAL_A_TO_Z)"
                >
                    <span cmpsButtonLabel>{{
                        _i18n._10042_ALPHABETICAL_A_TO_Z | translate
                    }}</span>
                </button>
                <button
                    class="cmps-button--no-bg cmps-button--left"
                    cmpsButton
                    (click)="_onOrderByClick(_OrderBy.ALPHABETICAL_Z_TO_A)"
                >
                    <span cmpsButtonLabel>{{
                        _i18n._10043_ALPHABETICAL_Z_TO_A | translate
                    }}</span>
                </button>
            </cmps-menu>
        </div>
    </div>
    <div class="d-flex">
        <input
            class="flex-grow-1 m-1"
            [placeholder]="_i18n._710_SEARCH | translate"
            [ngModel]="state?.filterOpts?.keyword ?? ''"
            (ngModelChange)="_onKeywordFilterChange($event)"
        />
        <button
            class="cmps-button--sm m-1"
            cmpsButton
        >
            <span cmpsButtonLabel>{{ _i18n._710_SEARCH | translate }}</span>
        </button>
        <button
            class="m-1"
            cmpsIconButton
            [cmpsTooltipTrigger]="_i18n._9665_RESET | translate"
            trigger="hover"
            (click)="_onResetClick()"
        >
            <cmps-icon svgIcon="reload"></cmps-icon>
        </button>
    </div>
</div>
<div class="transcript-body">
    <cmps-scrollbar>
        <cmps-accordion
            class="cmps-coaching-detail-pillar-two--accordion"
            [multi]="true"
        >
            <ng-container
                *ngFor="
                    let transCat of state?.filteredTranscriptCategories;
                    let i = index
                "
            >
                <cmps-accordion-item
                    [isOpen]="transCat.isOpen"
                    (isOpenChange)="_onCategoryOpenChange(transCat, $event)"
                    [attr.data-load-more-cat-index]="i"
                    [attr.data-load-more-ignore]="!transCat.isOpen"
                    [attr.data-load-more-implicitly-opened]="
                        transCat.implicitlyOpened
                    "
                >
                    <cmps-accordion-header>
                        <span
                            >{{ transCat.label | translate }} ({{
                                transCat.count
                            }})</span
                        >
                    </cmps-accordion-header>
                    <cmps-accordion-content>
                        <ng-container
                            *ngFor="
                                let subCategory of transCat.subCategories;
                                let i = index
                            "
                        >
                            <cmps-coaching-activity-status-wrapper
                                [attr.data-load-more-cat-index]="i"
                            >
                                <cmps-coaching-focus-item
                                    class="cmps-coaching-focus-item--focused"
                                    [behaviour]="
                                        subCategory.behaviourNameWithCount
                                    "
                                >
                                </cmps-coaching-focus-item>
                                <div
                                    class="no-transcripts"
                                    *ngIf="subCategory.transcripts.length <= 0"
                                >
                                    {{
                                        _i18n._10051_NO_TRANSCRIPTS_AVAILABLE
                                            | translate
                                    }}
                                </div>
                                <cmps-accordion
                                    class="transcript"
                                    [multi]="true"
                                >
                                    <ng-container
                                        *ngFor="
                                            let transcript of subCategory.transcripts
                                        "
                                    >
                                        <cmps-accordion-item
                                            [isOpen]="transcript.isOpen"
                                            (isOpenChange)="
                                                _onCategoryTranscriptOpenChange(
                                                    transcript,
                                                    $event
                                                )
                                            "
                                            [attr.data-transcript-id]="
                                                transcript?.transcriptId
                                            "
                                        >
                                            <cmps-accordion-header>
                                                <div class="transcript-item">
                                                    <cmps-ts-tooltip-conditional
                                                        selector=".transcript-item-title"
                                                    >
                                                        <ng-container
                                                            ngProjectAs="show"
                                                        >
                                                            <div
                                                                class="transcript-item-title"
                                                                [cmpsTooltipTrigger]="
                                                                    transcript?.title
                                                                "
                                                                trigger="hover"
                                                            >
                                                                <span>{{
                                                                    transcript?.title
                                                                }}</span>
                                                            </div>
                                                        </ng-container>
                                                        <ng-container
                                                            ngProjectAs="no-show"
                                                        >
                                                            <div
                                                                class="transcript-item-title"
                                                            >
                                                                <span>{{
                                                                    transcript?.title
                                                                }}</span>
                                                            </div>
                                                        </ng-container>
                                                    </cmps-ts-tooltip-conditional>
                                                    <div
                                                        class="transcript-item-date"
                                                    >
                                                        {{
                                                            transcript.createdDateTime
                                                                | cmpsDate
                                                                    : 'MM-dd-y h:mm a'
                                                        }}
                                                    </div>
                                                    <div>
                                                        <button
                                                            class="cmps-icon-button--no-bg"
                                                            cmpsIconButton
                                                            [cmpsTooltipTrigger]="
                                                                _i18n._10049_OPEN_TRANSCRIPT
                                                                    | translate
                                                            "
                                                            trigger="hover"
                                                            (click)="
                                                                $event.stopPropagation();
                                                                $event.preventDefault();
                                                                _onOpenTranscriptClick(
                                                                    transcript.transcriptId
                                                                )
                                                            "
                                                        >
                                                            <cmps-icon
                                                                svgIcon="open-in-new"
                                                            ></cmps-icon>
                                                        </button>
                                                        <button
                                                            class="cmps-icon-button--no-bg"
                                                            cmpsIconButton
                                                            [cmpsTooltipTrigger]="
                                                                _i18n._10050_DELETE_TRANSCRIPT
                                                                    | translate
                                                            "
                                                            trigger="hover"
                                                            (click)="
                                                                $event.stopPropagation();
                                                                $event.preventDefault();
                                                                _onDeleteTranscriptClick(
                                                                    transcript
                                                                )
                                                            "
                                                            *ngIf="
                                                                state
                                                                    ?.allowedActions
                                                                    ?.deleteTranscript
                                                            "
                                                        >
                                                            <cmps-icon
                                                                svgIcon="trash-can-outline"
                                                            ></cmps-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </cmps-accordion-header>
                                            <cmps-accordion-content>
                                                <div
                                                    class="transcript-summary-content"
                                                >
                                                    <div>
                                                        {{
                                                            _i18n._10048_SUB_BEHAVIOUR
                                                                | translate
                                                        }}
                                                    </div>
                                                    <div
                                                        class="transcript-summary-item"
                                                    >
                                                        {{
                                                            transcript
                                                                .primaryFocus
                                                                ?.subBehaviourName
                                                        }}
                                                    </div>
                                                    <div>
                                                        {{
                                                            _i18n._9301_DESCRIPTION
                                                                | translate
                                                        }}
                                                    </div>
                                                    <!--tiny-mce html (cmps-comment/cmps-coaching-note)-->
                                                    <div
                                                        class="transcript-summary-item"
                                                        [innerHTML]="
                                                            transcript.description
                                                        "
                                                    ></div>
                                                    <div>
                                                        {{
                                                            _i18n._9681_PARTICIPANTS
                                                                | translate
                                                        }}
                                                    </div>
                                                    <div class="tag-area">
                                                        <ng-container
                                                            *ngFor="
                                                                let participant of transcript.participants
                                                            "
                                                        >
                                                            <button
                                                                class="participant-tag"
                                                                cmpsButton
                                                            >
                                                                <span
                                                                    cmpsButtonLabel
                                                                    >{{
                                                                        participant
                                                                    }}</span
                                                                >
                                                            </button>
                                                        </ng-container>
                                                    </div>
                                                    <span>
                                                        {{
                                                            _i18n._10054_TRANSCRIPT_ID
                                                                | translate
                                                        }}
                                                        {{
                                                            transcript.transcriptId
                                                        }}
                                                    </span>
                                                </div>
                                            </cmps-accordion-content>
                                        </cmps-accordion-item>
                                    </ng-container>
                                </cmps-accordion>
                            </cmps-coaching-activity-status-wrapper>
                        </ng-container>
                        <button
                            class="load-more-button"
                            (click)="_onLoadMoreClick(transCat)"
                        >
                            <cmps-icon svgIcon="plus"></cmps-icon>
                            <span>{{
                                _i18n._10055_LOAD_MORE___ | translate
                            }}</span>
                        </button>
                    </cmps-accordion-content>
                </cmps-accordion-item>
            </ng-container>
        </cmps-accordion>
    </cmps-scrollbar>
</div>
